<script>
  import Demographics from '../../components/shared/forms/Demographics.svelte'
  import Zipcodes from '../../components/shared/forms/Zipcodes.svelte'
  import SelectCost from '../../components/tv-owner/forms/Select-Cost.svelte'
  import TimeOn from '../../components/tv-owner/forms/TimeOn.svelte'
  import getDemographicsModel from "../../js-core/models/demographics"
  export let extraVals = {}
  extraVals.demographic = getDemographicsModel()
  export let demographic
  export let costLowerBound
  export let costUpperBound
  export let timeOn
</script>

<Zipcodes isTvOwner=true bind:zipcodeValues={extraVals.demographic.location.zipcode} />
<!-- remove demographics for now -->
<!-- <Demographics bind:demographic={extraVals.demographic} isTvOwner=true /> -->
<!-- <h6>
  Price Range
</h6> -->
<!-- remove costs for now -->
<!-- <SelectCost bind:costLowerBound={extraVals.costLowerBound} bind:costUpperBound={extraVals.costUpperBound} /> -->
<!-- remove time for now -->
<!-- <TimeOn bind:value={extraVals.expectedOnTime} /> -->